import { memo, type ReactNode } from 'react';

import { dropdownMenuLabel } from '@air/primitive-dropdown-menu';
import { tailwindVariants, type VariantProps } from '@air/utils-tailwind';

const viewVisibilityMenuSection = tailwindVariants({
  base: 'flex flex-col',
  defaultVariants: {
    spacing: 'default',
  },
  variants: {
    spacing: {
      // Switch rows carry their own 32px height, so they stack tighter than the labelled controls.
      compact: 'gap-1',
      default: 'gap-2',
    },
  },
});

export type ViewVisibilityMenuSectionProps = VariantProps<typeof viewVisibilityMenuSection> & {
  children: ReactNode;
  label: string;
};

/**
 * Labelled section of the redesigned visibility menu. The label reuses the dropdown-menu label variant rather than
 * the component, which needs a Radix menu context this popover does not provide.
 */
export const ViewVisibilityMenuSection = memo(({ children, label, spacing }: ViewVisibilityMenuSectionProps) => {
  return (
    <div className={viewVisibilityMenuSection({ spacing })} data-testid="VIEW_VISIBILITY_MENU_SECTION">
      <span className={dropdownMenuLabel()} data-testid="VIEW_VISIBILITY_MENU_SECTION_LABEL">
        {label}
      </span>
      {children}
    </div>
  );
});

ViewVisibilityMenuSection.displayName = 'ViewVisibilityMenuSection';
